import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';

@Component({
    template: '<div></div>',
})
export class UserLogoutComponent {
    url:any
    constructor(private userService : UserService){
        this.url= environment.baseUrl + '/HuLoopSubscriptionUI'
    }
    ngOnInit() {
        this.userService.logoutUser();
    }

    logoutSso(){
        this.userService.getLoginFlag().subscribe(
            (res:any)=>{
                // if(res[0].value=='true'){
                   var logoutUrlFlag;
                    res = res['configFlags']
                    res.forEach(element => {
                        if(element.name=='azureEnabled' && element.value=='true'){                    
                            logoutUrlFlag = true;
                        }
                        if(logoutUrlFlag && element.name=='logoutServerUrl'){
                            var logoutUrl = element.value;
                            let updatedString = logoutUrl.replace("{logoutServerUrl}", this.url);
                            window.open(updatedString); 
                        }
                    });
                   
                // }
            
      
            }
        )
    }


}